/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationTenant {
    getFixupPrototypeFunction() { return RecommendationTenant.fixupPrototype; }

    static newInstance(model: Partial<RecommendationTenant>): RecommendationTenant {
        let obj = Object.assign(new RecommendationTenant(), model);
        RecommendationTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationTenant>): RecommendationTenant {
        if (!model) return null;
        return RecommendationTenant.newInstance(<RecommendationTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationTenant) {
        if (!obj) return;

        models.RecommendationTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationTenant): boolean {
        Object.setPrototypeOf(obj, RecommendationTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_counts) {
            models.ResourceCountTenant.fixupPrototype(this.resource_counts);
        }
    }

    /**
     * Recommendation id
     */
    id: string;

    /**
     * Policy Id
     */
    policy_id: string;

    /**
     * Policy Name
     */
    policy_name: string;

    /**
     * Name
     */
    name: string;

    /**
     * Status
     */
    status: string;

    /**
     * Impact
     */
    impact: string;

    /**
     * Classification based on OSCAR pillar
     */
    classification: string;

    /**
     * Sub Classification for the classification
     */
    sub_classification: string;

    /**
     * Cloud account id
     */
    cloud_account_id: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Cloud Service Name
     */
    service_name: string;

    /**
     * Source
     */
    source: string;

    /**
     * Time of creation
     */
    created_at: string;

    /**
     * Projected Cost Saving per Month
     */
    projected_cost_savings_month: string;

    /**
     * The resources that are open based on the recommendation
     */
    resource_counts: models.ResourceCountTenant;

}
